export default class ELeaveError extends Error {
  constructor(data) {
    super(data.Detail)
    this.statusCode = data.Status
    this.appResultCode = data.ELeaveResultCode
    this.message = data.Detail
  }
}
